/**
 * The chips Board 6 B draws for a choice — *Day 1 · Wed · Day 2 · Thu ·
 * ✓ Day 3 · Fri* (several) and *✓ Crew picks up · Vendor delivers to the
 * site* (one): the page's `ChoiceChip` at 30 (30px pills, 12.5/600, 12px either
 * side, 6px apart; a chosen one the selected-chip green with a 12px tick —
 * never a black chip), and at 44 on a phone (§19.2's touch targets).
 */
import { ChoiceChip } from './fields.js'

/** Several days at once — the Rent sheet's *Days*, Add equipment's days. */
export function DayChips({ days, value, onChange, phone, labelledBy }: {
  days: { index: number; label: string }[]
  value: number[]
  onChange: (next: number[]) => void
  phone: boolean
  labelledBy?: string
}) {
  return (
    <div role="group" aria-labelledby={labelledBy} className="flex flex-wrap items-center gap-1.5">
      {days.map((day) => {
        const on = value.includes(day.index)
        return (
          <ChoiceChip
            key={day.index}
            multi
            size={phone ? 44 : 30}
            on={on}
            onClick={() => onChange(on
              ? value.filter((index) => index !== day.index)
              : [...value, day.index].sort((a, b) => a - b))}
          >
            {day.label}
          </ChoiceChip>
        )
      })}
    </div>
  )
}

/** One of two or three — *How it gets there*. */
export function OneOfChips<T extends string>({ options, value, onChange, phone, labelledBy }: {
  options: { value: T; label: string }[]
  value: T
  onChange: (next: T) => void
  phone: boolean
  labelledBy?: string
}) {
  return (
    <div role="radiogroup" aria-labelledby={labelledBy} className="flex flex-wrap gap-1.5">
      {options.map((option) => (
        <ChoiceChip key={option.value} size={phone ? 44 : 30} on={option.value === value} onClick={() => onChange(option.value)}>
          {option.label}
        </ChoiceChip>
      ))}
    </div>
  )
}
